"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(ele) {
  return ele.scrollWidth > ele.clientWidth || ele.scrollHeight > ele.clientHeight;
};